export default __webpack_public_path__ + "secured-account.png?304604b770f472c1f5e819c6a110224a";